import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import TokenStore from '../lib/token_store.js';

class LogOutLink extends Component {
  clickHandler() {
    TokenStore.reset()
  }

  render() {
    return (
      <Link onClick={this.clickHandler} {...this.props} to="#">
        {this.props.children}
      </Link>
    )
  }
}

export default LogOutLink;



// WEBPACK FOOTER //
// ./src/components/logout_link.js